// eslint-disable-next-line import/no-unused-modules, import/order
import React from "react";

// eslint-disable-next-line import/order
import { createRoot } from 'react-dom/client';

//Import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { LanguageProvider } from "./provider/LanguageProvider";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);
root.render(<BrowserRouter>
    <LanguageProvider>
        <App />
    </LanguageProvider>
</BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// Unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//ServiceWorkerRegistration.register();
